import { Component, OnInit, HostListener, OnDestroy, Output, EventEmitter, Input, SimpleChanges, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { SimpleXploreItemDTO } from 'src/app/shared/object/xplorer-be-parsed-classes';
import { environment } from "../../../../environments/environment";
import { ImageManager } from "../../../shared/image-manager";
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'xplorer-bowser-close-destinations',
    templateUrl: './close-destinations.component.html',
    styleUrls: ['./close-destinations.component.css'],
    imports: []
})

export class CloseDestinationsComponent implements OnInit {

  displayedXploreItems: SimpleXploreItemDTO[];
  screenWidth: number;

  @Input() allXploreItems: SimpleXploreItemDTO[];
  @Input() loading: boolean;

  private router: Router = inject(Router);
  private translate: TranslateService = inject(TranslateService);
  private platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);


  ngOnInit() {
    this.updateDisplayedCards();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['allXploreItems'] && this.allXploreItems) {
      this.updateDisplayedCards();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateDisplayedCards();
  }

  updateDisplayedCards() {
    if (this.allXploreItems && this.allXploreItems.length > 0) {
      const limit = this.getCardLimit();
      this.displayedXploreItems = this.allXploreItems.slice(0, limit);
    }
  }

  getCardLimit(): number {
    if (!this.isBrowser) {
      return 5;
    }
    return window.innerWidth < 1024 ? 5 : 5;
  }

  getImage(imageUrl: string) {
    return imageUrl ? environment.IMAGES_URL + imageUrl : ImageManager.getPlaceholderImage();
  }

  navigateTo(url: string): void {
    this.router.navigate([url]);
  }

  getItemImageUrl(simpleXploreItemDTO: SimpleXploreItemDTO) {
    return (simpleXploreItemDTO.multiMediaUrls && simpleXploreItemDTO.multiMediaUrls.length > 0)
      ? this.getImage(simpleXploreItemDTO.multiMediaUrls[0])
      : ImageManager.getPlaceholderImage();
  }

  getItemUrl(xploreItem: SimpleXploreItemDTO) {
    return `/explore/${xploreItem.id}`;
  }

  getItemLocation(xploreItem: SimpleXploreItemDTO) {
    const locationName = xploreItem.geoPosition?.location?.comune?.name || xploreItem.geoPosition?.comune?.name;
    return locationName ? locationName : this.translate.instant('home.location_unavailable');
  }
}
